/* esm.sh - applesauce-common@5.2.0/helpers/app-data */
export * from "/*applesauce-common@5.2.0/esnext/helpers/app-data.mjs";
